export default __webpack_public_path__ + "static/media/kiemphong.df7b9122.png";